// eslint-disable-next-line no-console
console.log('Registered beforeunload');
// eslint-disable-next-line no-unused-vars
window.addEventListener('beforeunload', function (e) {
  if (globalThis.finformUnsavedChanges) {
    e.preventDefault();
    e.returnValue = '';
  }
});
